module.exports = __webpack_public_path__ + "static/img/logo.32875c4.png";


//////////////////
// WEBPACK FOOTER
// ./static/banner/logo.png
// module id = etEC
// module chunks = 1